import { render } from "./loading-bar.html?vue&type=template&id=0911e944&scoped=true&ts=true"
import script from "./loading-bar.vue?vue&type=script&lang=ts"
export * from "./loading-bar.vue?vue&type=script&lang=ts"

import "./loading-bar.scss?vue&type=style&index=0&id=0911e944&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0911e944"]])

export default __exports__